import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const orcaSecurity = defineConnector({
  identifier: "orcaSecurity",
  name: "Orca Security",
  tagLine: "Cloud security platform",
  logo,
  protocol: "http",
  tags: ["security"],
  defaultUrlPattern: () => "https://api\\.(?:[^/]*\\.)?orcasecurity\\.io/.*",
  auth: (app) =>
    headerAuth([
      { name: "Authorization", value: app.secret.apiToken, scheme: "Token" },
    ]),
  steps: [
    {
      title: "Get your API token",
      items: [
        {
          kind: "markdown",
          content:
            "In the [Orca Security](https://orcasecurity.io) console, go to **Settings > Integrations > API** to generate an API token.",
        },
      ],
    },
    {
      title: "Enter your Orca Security details",
      items: [
        {
          kind: "select",
          label: "Region",
          required: true,
          target: { kind: "configuration", field: "region" },
          options: [
            { value: "api.orcasecurity.io", label: "US" },
            { value: "api.eu.orcasecurity.io", label: "EU" },
          ],
          helperText:
            "Select the region where your Orca Security account is hosted.",
        },
        {
          kind: "input",
          label: "API token",
          required: true,
          target: { kind: "secrets", field: "apiToken" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ region }) => `https://${region}/api/user/action`,
  },
  publicEnvVars: ({ region }) => ({
    ORCA_SECURITY_URL: region ? `https://${region}` : "",
  }),
});
